import { useSelector } from "react-redux";
import { useGetChatListDataQuery } from "../../../../store/queries/Admin";
import { useState } from "react";

const useChatList = () => {
  const aiordersState = useSelector((state) => state.aiorders);
  const [activeAudioId, setActiveAudioId] = useState(null);

  const handleAudioPlay = (id) => {
    setActiveAudioId(id);
  };
  const {
    data: orderBasicData = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetChatListDataQuery({
    mobile: aiordersState?.mobile,
    // aiordersState?.mobile,
    chat_section_id: aiordersState?.chatSectionId,
  });

  return {
    orderBasicData,
    isLoading,
    isFetching,
    activeAudioId,
    handleAudioPlay,
    refetch,
    aiordersState,
  };
};

export default useChatList;
